module.exports = __webpack_public_path__ + "img/brillante_12.b740ced3.svg";